import apiClient from '../../api/http-common';

const getFarmerUsersIndexData = ():any =>
  apiClient.post('/farmers/users/get-index-data')

const getFarmerUsersCount = (data?):any =>
  apiClient.post('/farmers/users/count', data)

const getFarmerUsersIndex = (data?):any => {
  return apiClient.post<IFarmerUsersData>('/farmers/users/index', data)
}

const FarmerUsersService = {
  getFarmerUsersIndexData,
  getFarmerUsersIndex,
  getFarmerUsersCount
}

export interface IFarmerUsersData {
  data: {
    filtered: number;
    rows: any[];
    total: number;
  }
}

export default FarmerUsersService
